import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_BOLSA_POVO } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestAlteraEndereco } from './types';

// ACTIONS
import { alteraEnderecoSuccess, alteraEnderecoFailure } from './action';

function* alteraEndereco(request: ReducerAction) {
	const { payload }: { payload: IRequestAlteraEndereco } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_BOLSA_POVO,
		`bolsa-povo/${CHANNEL}/altera-endereco`,
		payload,
	);

	if (response.status === 200) {
		yield put(alteraEnderecoSuccess(response));
	} else if (response.error) {
		yield put(alteraEnderecoFailure());
	}
}

export default all([takeLatest(Types.ALTERA_ENDERECO, alteraEndereco)]);
